<template>
  <div class="auth-dialog" v-if="show">
    <div class="auth-dialog-content">
      <img v-if="success" src="../../assets/images/authentication/check.png" alt="">
      <img v-else src="../../assets/images/authentication/err.png" alt="">
      <h5>提交{{success? '成功': '失败'}}！</h5>
      <p v-if="success">系统审核中，预计<span>1-3个工作日</span>完成审核</p>
      <p v-else>信息提交有误，请重新上传提交</p>
      <div class="content-bottom" :style="this.provide ? { background: '#EDF7FF'}: {}">
        <short-btn :text="success? '关闭': '重新验证'" :canUse="true" @confirm="confirm" :blue="this.provide"/>
      </div>
    </div>
  </div>
</template>

<script>
import ShortBtn from './ShortBtn'
export default {
  name: 'AuthDialog',
  props: {
    // 是否显示
    show: {
      type: Boolean,
      default: false,
    },
    // 是否成功
    success: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    ShortBtn
  },
  computed: {
    provide () {
      return this.$route.query.provide === 'ciba'
    }
  },
  methods: {
    confirm() {
      this.$emit('confirm', this.success)
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "../../style/main";

  .auth-dialog {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(#000, 0.5);
    text-align: center;

    &-content {
      width: use(506);
      background: #FFFFFF;
      border-radius: use(16);
      overflow: hidden;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -60%);
      padding-top: use(45);
      box-sizing: border-box;
      letter-spacing: use(1);

      img {
        width: use(80);
        height: use(80);
        margin-bottom: use(15);
      }

      h5 {
        font-weight: bold;
        font-size: use(34);
        color: #4A4A4A;
        text-align: center;
        text-indent: use(30);
        margin-bottom: use(38)
      }

      p {
        font-family: PingFangSC-Medium;
        font-size: use(26);
        color: #6D6055;
        text-align: center;
        line-height: 1.4;
        padding: 0 use(68);
        margin-bottom: use(36);

        span {
          color: #FF6F25;
        }
      }

      .content-bottom {
        width: 100%;
        background: #FAF6F1;
        padding: use(38) 0;
      }

    }
  }
</style>
